import { get, getTrackingString } from '../../utils/object-helpers';

export default class {
    onInput(input) {
        const contact = get(input, 'page.modules.CONTACT_SELLER_MODULE', null);
        return {
            url: get(contact, 'contactAction.action.URL', ''),
            label: get(contact, 'contactAction.text', ''),
            tracking: getTrackingString(contact, 'contactAction.action.trackingList')
        };
    }
}
